import { connect } from 'react-redux';

import MetricsTableHeadersComponent
  from './../Components/MetricsTableHeadersComponent.jsx';
import { setMetricsSorter } from './../actions';
import {
  getMetricsSorter,
  getBaselineBuildInfo
} from './../reducers';

export const mapStateToProps = (state) => {
  const baselineBuildInfo = getBaselineBuildInfo(state);

  return {
    sorter: getMetricsSorter(state),
    isExpected: baselineBuildInfo.buildType === 'Expected'
  };
};

export default connect(
  mapStateToProps,
  { onSorterChange: setMetricsSorter }
)(MetricsTableHeadersComponent);


// WEBPACK FOOTER //
// src/Containers/MetricTableHeadersContainer.jsx